const defaultColor = '#202124';

export default defaultColor;
